import {buildField} from '@eitje/form'
import * as React from 'react'
import * as _ from 'lodash'
import {MultipleDatePicker} from '~/components'
import {formatMultipleDates} from '@eitje/utils'
import {DatePickerFieldTrigger} from '../root'

export const MultipleDatePickerField = React.memo(
	buildField(
		fieldProps => {
			return (
				<MultipleDatePicker
					{...fieldProps}
					renderTrigger={ctx => {
						const hasValue = ctx.value.length > 0
						let displayValue = fieldProps.placeholder

						if (hasValue && !fieldProps.displayFormatFn) displayValue = formatMultipleDates(ctx.value)
						if (hasValue && fieldProps.displayFormatFn) displayValue = fieldProps.displayFormatFn(ctx.value)

						return <DatePickerFieldTrigger isPlaceholderShown={!hasValue}>{displayValue}</DatePickerFieldTrigger>
					}}
				/>
			)
		},
		{className: 'date-picker-field', icon: true},
	),
	_.isEqual,
)
